import { GET_MOVIES, SET_LOADING, SET_ERROR, UPDATE_MOVIES, SET_LOADING_UPDATE } from "../actionTypes";

const initial_state = {
  movies: [],
  moviesLoading:  true,
  moviesError: {},
  movie: {},
  loadingUpdate: true
}

export default function moviesReducer(state = initial_state, action) {  
  switch (action.type) {
    case GET_MOVIES:
      return {...state, movies: action.payload}
    case SET_LOADING: 
      return {...state, moviesLoading: action.payload}
    case SET_ERROR: 
      return {...state, moviesError: action.payload}
    case UPDATE_MOVIES: 
      return {...state, movie: action.payload}
    case SET_LOADING_UPDATE:
      return {...state, loadingUpdate: action.payload}
    default:
      return state
  }
}